import React, {useState} from 'react';
import {Input, Modal, SimpleButton} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import CustomerService from "../services/CustomerService";
import RestoreEnvService from "../services/RestoreEnvService";
import { ProjectAccents } from "../../General/config/projectAccents";

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

function RestoreLiveToTestModal(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, handleCustomerMenuModalClose: Function, setLoading: Function, setAlert: Function }) {

    const [enteredClientId, setEnteredClientId] = useState<number>();
    const [testCustomer, setTestCustomer] = useState<CustomerDTO>();
    const [confirmTestCustomerModalVisible, setConfirmTestCustomerModalVisible] = useState(false);

    const renderModalContent = () => {
        let modalContent;
        modalContent = (
            <>
                <Input
                    placeholder="Enter Client ID"
                    clearButton
                    style={{ width: '200px' }}
                    onChange={(e) => setEnteredClientId(e.currentTarget.value)}
                />
            </>
        )

        return modalContent;
    }
    
    const handleMainModalCheckButtonClick = () => {
        if (enteredClientId) {
            CustomerService.getCustomerByClientId(enteredClientId, props.selectedCustomer.environmentName)
                .then((result) => {
                    result.appgrp = result.appGroup
                    setTestCustomer(result)
                    setConfirmTestCustomerModalVisible(true)
                })
        }
    }
    
    const handleRestoreConfirmed = async () => {
        if (!testCustomer?.clientId) {
            throw new Error();
        }

        props.setLoading('Starting restore...');
        
        try {
            const response = await RestoreEnvService.restoreLiveToTest(props.selectedCustomer.clientId, testCustomer.clientId, props.selectedCustomer.environmentName);
            const taskId = response.taskId;

            let status;
            do {
                await delay(2000);
                status = await RestoreEnvService.getRestoreLiveToTestStatus(taskId);
                props.setLoading(status.progressMessage || 'Restoring...');
            } while (!status.complete && !status.errorMessage);
            
            if (status.errorMessage) {
                props.setAlert({type: 'error', message: status.errorMessage});
            } else {
                props.setAlert({type: 'success', message: 'Env Restore complete'});
            }
        } catch (e) {
            props.setAlert({type: 'error', message: 'An error has occurred, please contact HSC Care DevOps'});
        } finally {
            props.setLoading(false);
            props.handleClose();
            props.handleCustomerMenuModalClose();
        }
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PeoplePlanner}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
            heading={`Restore '${props.selectedCustomer.name}' onto test environment`}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            additionalButtons={
                <>
                    <SimpleButton buttonStyle={{ marginRight: '10px' }} onClick={() => handleMainModalCheckButtonClick()}>Check</SimpleButton>
                </>
            }
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
            {confirmTestCustomerModalVisible ?
                <Modal
                    heading={"Please Confirm"}
                    visible={confirmTestCustomerModalVisible}
                    onClose={() => setConfirmTestCustomerModalVisible(false)}
                    onPrimaryButtonClick={() => handleRestoreConfirmed()}
                >
                    Are you sure you want to restore...
                    <br />
                    <br />
                    {props.selectedCustomer.name} from {props.selectedCustomer.appgrp}
                    <br />
                    onto
                    <br />
                    {testCustomer?.name} from {testCustomer?.appgrp}?
                </Modal> : undefined
            }
        </>
    )

}

export default RestoreLiveToTestModal;
